"use strict";
// Shared border color evaluator
// Provides parsing and serialization for individual border color properties
// Used by border-top-color, border-right-color, border-bottom-color, border-left-color
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseBorderColorProperty = parseBorderColorProperty;
exports.borderColorToCSSValue = borderColorToCSSValue;
const color_1 = require('./color.cjs');
const shared_utils_1 = require('../utils/shared-utils.cjs');
const css_variable_1 = require('./css-variable.cjs');
/**
 * Check if value is a border color keyword
 */
function isBorderColorKeyword(value) {
    return value.toLowerCase() === 'currentcolor';
}
/**
 * Parse a border color property value (color value or keyword)
 * Accepts color values and border color keywords (currentcolor)
 *
 * @param value - CSS border color value string
 * @returns Parsed border color value or null if invalid
 */
function parseBorderColorProperty(value) {
    if (!value || typeof value !== 'string') {
        return null;
    }
    const trimmed = value.trim();
    if (trimmed === '') {
        return null;
    }
    // CSS variables - return proper CSSVariable object
    if ((0, shared_utils_1.isCssVariable)(trimmed)) {
        return (0, css_variable_1.parse)(trimmed);
    }
    // Global keywords
    if ((0, shared_utils_1.isGlobalKeyword)(trimmed)) {
        return { type: 'keyword', keyword: trimmed.toLowerCase() };
    }
    // Border color keyword (currentcolor)
    if (isBorderColorKeyword(trimmed)) {
        return { type: 'keyword', keyword: 'currentcolor' };
    }
    // Color values - delegate to color evaluator
    const colorResult = (0, color_1.parse)(trimmed);
    if (colorResult && 'format' in colorResult) {
        // Only return actual color values, not CSS variables
        return colorResult;
    }
    return null;
}
/**
 * Convert a border color property value back to CSS string
 *
 * @param parsed - Parsed border color value
 * @returns CSS string representation or null if invalid
 */
function borderColorToCSSValue(parsed) {
    if (!parsed) {
        return null;
    }
    // Handle CSS variables
    if ('CSSvariable' in parsed) {
        return (0, css_variable_1.toCSSValue)(parsed);
    }
    // Handle keyword values (global keywords and currentcolor)
    if ('keyword' in parsed) {
        return parsed.keyword;
    }
    // Handle color values
    return (0, color_1.toCSSValue)(parsed);
}
